import shopifyGenericDefaults from '../shopify-generic/config.js';

const ignoreFields = ['wheel_tire_diameter'];

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  Widgets: [
    ...shopifyGenericDefaults.Widgets.map((widget) =>
      widget.name === 'Facets' || widget.name === 'FilterChips'
        ? { ...widget, ignoreFields: [...(widget.ignoreFields ?? []), ...ignoreFields] }
        : widget,
    ),
    {
      name: 'UpsizeDownsizeFacetPanel',
      type: 'FacetPanel',
      fields: ['wheel_tire_diameter'],
      showAllAlways: true,
      disableCollapse: true,
    },
  ],
};
